export interface ILimitAmts {
  LimitAmtType?: number// 1631
  LastLimitAmt?: number// 1632
  LimitAmtRemaining?: number// 1633
  LimitUtilizationAmt?: number// 2394
  LimitAmt?: number// 2395
  LimitAmtCurrency?: string// 1634
  LimitRole?: number// 2396
}
